{
	"app_fallbacks": {
		"error": {
			"description": "Si è verificato un errore imprevisto durante il rendering di questa pagina. Puoi riprovare oppure tornare a un'area funzionante dell'app.",
			"title": "Qualcosa è andato storto."
		},
		"go_back": "Indietro",
		"go_home": "Vai alla home",
		"loading": "Caricamento",
		"not_found": {
			"description": "La pagina che stai cercando non esiste o potrebbe essere stata spostata. Torna a un'area funzionante dell'app.",
			"title": "Pagina non trovata."
		},
		"permission_error": {
			"description": "Non hai i permessi per accedere a questa pagina.",
			"title": "Accesso negato"
		},
		"try_again": "Riprova"
	},
	"app_sidebar": {
		"back_to_drive": "Torna a Drive",
		"brand_logo_alt": "Logo di {{product}}",
		"drive": "Drive",
		"menu": {
			"logout": "Esci"
		},
		"storage": {
			"available": "Ancora disponibili: {{available}}",
			"full": "Spazio esaurito",
			"label": "Spazio usato",
			"organization_full": "Spazio dell'organizzazione esaurito",
			"title": "Archiviazione",
			"used": "<b>{{used}}</b> usati",
			"used_of": "<b>{{used}}</b> di <b>{{quota}}</b> usati"
		},
		"user_menu": {
			"open": "Apri menu utente"
		}
	}
}
